<template>
  <modal name="historyModal" class="event-modal right-modal" :width='"50%"' :height="'auto'" :scrollable="true"
         :pivotX="1.0" :minHeight="900">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>Change History</span>
      </div>
      <div class="modal-close-img" @click="hideModal()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
      </div>
    </div>
    <div class="modal-body">
      <div v-for="history in getEventHistory">
        <HistoryModalSection :history="history"></HistoryModalSection>
      </div>
    </div>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex';

  import HistoryModalSection from './HistoryModalSection';

  export default {
    name: '',
    components: {
      HistoryModalSection
    },
    data () {
      return {
        isHoverClose: false,
        isExpanded: false
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('historyModal');
      }
    },
    computed: {
      ...mapGetters({
        getEventHistory: 'GETTERS_GET_EVENT_HISTORY'
      })
    }
  }
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .right-modal {
    margin: 0;
    background: rgba(0, 0, 0, 0.4);
    padding-top: 0;
    padding-bottom: 0 !important;

    .modal-close-button {
      float: right;
      font-size: 20px;
      &:hover {
        cursor: pointer;
      }
    }

    .modal-header {
      border: 0;
      width: 100%;
      margin: 0 auto;

      .line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid #E6E6E6;
      }
      .modal-header-text {
        margin-top: 50px;
        color: #231f20;
        font-weight: bold;
        text-transform: capitalize;
        border-bottom: 1px solid #c2cfd6;
        width: 80%;
        height: 27px;
        font-family: @font-family-main;
        font-size: 20px;
        line-height: 27px;
        padding-bottom: 35px;
      }
      .modal-header-change-order-text {
        margin-top: 25px;
        margin-left: 25px;
        height: 29px;
        width: auto;
        color: @black;
        font-family: @font-family-title;
        font-size: 24px;
        font-weight: bold;
        line-height: 29px;
        text-transform: uppercase;
      }
      .modal-header-line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid @grey-4;
      }
      .modal-close-img {
        position: absolute;
        right: 17px;
        top: 17px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .modal-body {
      height: auto;
      width: 100%;
      margin: 0 auto;
      padding: 0 60px 25px 40px;
      .history-section {
        padding: 20px 0;
        // border-bottom: solid 1px @grey-4;
        &:last-child {
          border-bottom: none;
        }
        .modal-body-title {
          font-family: @font-family-main;
          height: 22px;
          color: #231F20;
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          float: left;
        }
        .modal-body-time {
          float: left;
          margin-left: 8px;
        }
        .modal-body-collapse-btn {
          height: 35px;
          width: 117px;
          border-radius: 4px;
          background-color: #E6E6E6;
          padding: 0 10px;
          line-height: 35px;
          margin-top: 10px;
          &:hover {
            cursor: pointer;
          }
          .fa-icon {
            padding-top: 5px;
          }
        }
        .modal-body-table {
          margin-top: 15px;
          .table {
            // line-height: 10px;
            th {
              background-color: #e6e6e6;
              border-color: #e6e6e6;
              border-bottom: solid 1px #e6e6e6;
              width: 99px;
              color: #231F20;
              font-family: @font-family-main;
              font-size: 14px;
              font-weight: 600;
            }
            td {
              border-color: #e6e6e6;
            }
          }
        }
        .modal-body-comments {
          color: #231F20;
          font-family: @font-family-main;
          font-size: 14px;
        }
        .modal-body-sub-title {
          font-weight: 600;
        }
        .modal-body-text {
          color: @black;
          font-family: @font-family-main;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// HistoryModal.vue?2e3d4ac5